<p-card class="p-3" header="Datos generales">
    <form *ngIf="taskFormGroup" [formGroup]="taskFormGroup">

        <div class="grid">
            <div class="col-12 input-field">
                <label for="description">Descripción *</label>
                <textarea #autoGrowTextarea pInputTextarea style="max-height: 500px; overflow-y: hidden; resize: none;" (input)="this.stringUtils.ResizeTextarea($event, 500)" rows="5" formControlName="description"
                    d-form-field-error></textarea>
            </div>
            <div class="col-4 input-field">
                <label for="userId">Usuario asignado *</label>
                <p-dropdown formControlName="userId" [options]="users" optionLabel="name" optionValue="id"  (onFilter)="loadUsers($event)"
                    [filter]="true" filterBy="name" placeholder="Selecciona un usuario" d-form-field-error></p-dropdown>
            </div>
            <div class="col-2 input-field">
                <label for="date">Fecha *</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="date" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" [hourFormat]="'24'" d-form-field-error></p-calendar>
            </div>
            <div class="col-2 input-field">
                <label for="isCompleted">Completada</label>
                <p-inputSwitch formControlName="isCompleted" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-2 input-field">
                <label for="notifyStatusChanges">Notificar cambio de estado</label>
                <p-inputSwitch formControlName="notifyStatusChanges" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-2 input-field">
                <label for="isUrgent">Urgente</label>
                <p-inputSwitch formControlName="isUrgent" d-form-field-error></p-inputSwitch>
            </div>
        </div>
        <div class="mt-4 flex gap-2">
            <p-button label="Eliminar" *ngIf="allowDelete && task?.id" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-plus" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </form>
</p-card>
<p-card *ngIf="task.id" class="p-3" header="Comentarios">

    <div *ngIf="comments.length === 0" class="text-center text-gray-500 py-5">
        No hay comentarios para esta tarea.
    </div>
    <div *ngFor="let comment of comments" class="pb-2">
        <p-card class="p-card-content-pt-0 p-card-body-pt-0  p-card-body-pb-0 " [style]="{ background: '#f4f4f4' }"  >
            <ng-template pTemplate="header">
                <div class="flex justify-content-between align-items-center">
                    <div><b>{{comment.createdByUser?.name}}</b></div>
                    <div>{{comment.date | date:'dd/MM/yyyy HH:mm'}}</div>
                </div>
            </ng-template>
            <div class="editor" [innerHtml]="comment.description"></div>
        </p-card>
    </div>
    <div class="mt-4 flex gap-2">
            <p-button label="Nuevo comentario" icon="pi pi-plus" styleClass="p-ml-2"
                (click)="addComment()"></p-button>
        </div>
</p-card>

<p-messages *ngIf="case" severity="info">
    <ng-template pTemplate>
        Esta tarea está asociada con el expediente&nbsp;<a [routerLink]="['/cases', case.id]"
            target="_blank">{{case.caseNumber}}</a>.
    </ng-template>
</p-messages>

<p-confirmDialog></p-confirmDialog>


<p-dialog header="Nuevo Comentario" [(visible)]="commentModal" appendTo="body" [modal]="true" [closable]="true" [style]="{width: '500px'}">
    <div class="col-12 input-field ">
        <p-editor [(ngModel)]="newComment.description"  [style]="{ height: '120px' }">
            <ng-template pTemplate="header">
                <span class="ql-formats">
                    <button type="button" class="ql-bold" aria-label="Negrita"></button>
                    <button type="button" class="ql-italic" aria-label="Cursiva"></button>
                    <button type="button" class="ql-underline" aria-label="Subrayado"></button>
                </span>
            </ng-template>
        </p-editor>
    </div>

    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancelCommentModal()"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveComment()"></button>
    </ng-template>
<p-confirmDialog></p-confirmDialog>
</p-dialog>